// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus  controllerName

import { application } from './application';

import AlertsController from './alerts_controller';
application.register('alerts', AlertsController);

import SidebarController from './sidebar_controller';
application.register('sidebar', SidebarController);
